/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The type of the card.
 */
export const CardType = {
  Debit: "debit",
  Credit: "credit",
  Prepaid: "prepaid",
  Unknown: "unknown",
} as const;
/**
 * The type of the card.
 */
export type CardType = ClosedEnum<typeof CardType>;

/** @internal */
export const CardType$inboundSchema: z.ZodNativeEnum<typeof CardType> = z
  .nativeEnum(CardType);
/** @internal */
export const CardType$outboundSchema: z.ZodNativeEnum<typeof CardType> =
  CardType$inboundSchema;
